import axios from 'axios';

const hostUrl = `${process.env.REACT_APP_HOST_URL}Data-management`;

const StationService = {
  saveActiveStations(id, data) {
    const url = `${hostUrl}/Market/${id}/station/save-active`;
    return axios.post(url, data);
  },

  getActiveStations(id, data) {
    const url = `${hostUrl}/Market/${id}/client-station/active`;
    return axios.post(url, data);
  },

  getStations(id, data) {
    const url = `${hostUrl}/Market/${id}/stations`;
    return axios.post(url, data);
  },

  getMarkets(id, clientId, selectedType, filterClientSpecificMarkets) {
    let url = `${hostUrl}/Market?organisationId=${id}&networkType=${selectedType}`;

    if (clientId) url += `&ClientId=${clientId}&filterClientSpecific=${filterClientSpecificMarkets}`;

    return axios.get(url);
  },

  saveClientActiveStations(id, data) {
    const url = `${hostUrl}/Market/${id}/client-station/save-active`;
    return axios.post(url, data);
  },

  getClientActiveStations(id, data) {
    const url = `${hostUrl}/Market/${id}/client-station/active`;
    return axios.post(url, data);
  },

  getClientStations(id, data) {
    const url = `${hostUrl}/Market/${id}/client-stations`;
    return axios.post(url, data);
  },

  updateStationAlias(stationId, data) {
    const url = `${hostUrl}/station/${stationId}/update`;
    return axios.patch(url, data);
  },
};

const superAdminHostUrl = `${process.env.REACT_APP_HOST_URL}global`;

// Super Admin Station Services

export const SuperAdminStationService = {
  getGlobalStations() {
    const url = `${superAdminHostUrl}/stations`;
    return axios.get(url);
  },
  getGlobalStationFormLookups() {
    const url = `${superAdminHostUrl}/stations/form-lookups`;
    return axios.get(url);
  },
  getSingleGlobalStation(stationId) {
    const url = `${superAdminHostUrl}/stations/${stationId}`;
    return axios.get(url);
  },
  createGlobalStation(json) {
    const url = `${superAdminHostUrl}/stations`;
    return axios.post(url, json);
  },
  updateSingleGlobalStation(stationId, json) {
    const url = `${superAdminHostUrl}/stations/${stationId}`;
    return axios.put(url, json);
  },
  getTpuid() {
    const url = `${process.env.REACT_APP_HOST_URL}Organisation/create_uid`;
    return axios.get(url);
  },
  getGlobalMarketsByType(networkType) {
    const url = `${process.env.REACT_APP_HOST_URL}global/stations/global-market?networkType=${networkType}`;
    return axios.get(url);
  },
}



export default StationService;
